import axios from "../../lib/axios";

export async function postRating(rating, closetId) {
  const res = await axios.post("/users/feedbacks", {
    rating,
    closet_id: closetId,
  });
  return res.data;
}

export async function putFeedback(id, data) {
  const res = await axios.put(`/users/feedbacks/${id}`, {
    comment: data,
  });
  return res.data.data;
}
